import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AssessService } from '../../../services/assess.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionHandlerService } from '@clients-nside-io/shared/util';
import { SidebarHighlightService } from '../../../services/sidebar-highlight.service';
import { DebugUtils } from '@clients-nside-io/shared/util';
import { ToastrService } from 'ngx-toastr';
import { AssessForms } from '../../../models/Constants';
import { AssessStages } from '../../../models/AssessGeneral';
import { AssessStageBaseComponent } from '../../shared/AssessStageBase.component';
import { LocalStoreService } from '@clients-nside-io/shared/services';

@Component({
  selector: 'clients-nside-io-monitoring',
  templateUrl: '../../shared/AssessStageBase.component.html',
  // templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss']
})
export class MonitoringComponent extends AssessStageBaseComponent implements OnInit, OnDestroy {
  public myTitle = 'Monitoring';
  protected readonly myStageName: AssessStages = AssessStages.monitoring;
  protected readonly myFormDisplayNames: string[] = AssessForms.displayNames.monitoring;
  protected readonly myFormNames: string[] = AssessForms.names.monitoring;
  protected readonly myReviewFormNumber: number = 1;
  protected readonly myReviewForm: string = this.myFormNames[this.myReviewFormNumber - 1];

  constructor(
    protected assessService: AssessService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected modalService: NgbModal,
    protected actionHandlerService: ActionHandlerService,
    protected toastr: ToastrService,
    protected debug: DebugUtils,
    protected sidebarHighlighter: SidebarHighlightService,
    localStore: LocalStoreService
  ) {
    super(assessService, route, router, modalService, actionHandlerService, toastr, debug, sidebarHighlighter, localStore);
  }

  // private formDisplayNames = AssessForms.displayNames.monitoring;
  //
  // isOpeningForm = false;
  // buildingId = null;
  // monitoringData: any = null;
  // temp = [];
  // closeResult = '';
  //
  // currentActionHistory: any[] = null;
  // currentClickedCaseId: string;
  //
  // //for case reviewing
  // currentCase: any;
  // currentUserId: any;
  // reviewerEmail = '';
  //
  //
  //
  // //current case number
  // stageJobsCount = {
  //   Evaluations: 0,
  //   Assessments: 0,
  //   Plans: 0,
  //   Interventions: 0,
  //   Monitoring: 0,
  //   Closed: 0,
  // };
  //
  // //attachments list
  // attachmentsCompletedForms = null;
  // attachmentsInProgressForms = null;
  // attachmentsFileLinks = null;
  // //----------------
  //
  // getSendMessageSubcription: Subscription;
  //
  // @ViewChild(DatatableComponent) table: DatatableComponent;
  //
  // @ViewChild('teamSelection') designatedTeamSelectionModal: TemplateRef<any>;
  // @ViewChild('teamSelectionConsider')
  // teamSelectionConsiderModal: TemplateRef<any>;
  //
  // //assessment team data
  // assessmentTeamList: any[] = [];
  //
  // teamSelectionTitle = '';
  // isSelectingTeamMember = false;
  // private reloader$ub: Subscription;
  //
  //
  // constructor(
  //   private assessService: AssessService,
  //   private route: ActivatedRoute,
  //   private router: Router,
  //   private modalService: NgbModal,
  //   private actionHandlerService: ActionHandlerService,
  //   private sidebarHighlighter: SidebarHighlightService,
  //   private debug: DebugUtils,
  //   private toastr: ToastrService
  // ) { }
  //
  // ngOnDestroy(): void {
  //   this.reloader$ub?.unsubscribe();
  // }
  //
  // ngOnInit(): void {
  //   localStorage.setItem('currentUrl', this.router.url);
  //
  //   // update userId
  //   this.currentUserId = this.assessService.getActiveUserId()
  //     ?? localStorage.getItem('currentAssessUserId');
  //
  //   this.sidebarHighlighter.highlightSideBar(this.router);
  //
  //   //get building id
  //   this.buildingId = this.route.parent.snapshot.paramMap.get('buildingId');
  //
  //   localStorage.setItem('buildingId', this.buildingId);
  //   localStorage.setItem('currentAssessBuildingId', this.buildingId);
  //
  //   this.loadData();
  //   this.reloader$ub = interval(90000).subscribe(() => {
  //     this.loadData();
  //   });
  //
  //   // show success messenger after finish the form (from form project)
  //   this.getSendMessageSubcription = this.actionHandlerService
  //     .getSendMessageHandler()
  //     .subscribe((message: any) => {
  //       this.toastr.success(message, 'Message:');
  //       this.loadData();
  //       this.isOpeningForm = false;
  //     });
  //   //----------------------------------------------------------------
  //
  //   // redirect to the corresponded form, when user need -------------
  //   this.debug.log('The current url is:', this.router.url);
  //
  //   const formTypes = AssessForms.names.monitoring;
  //
  //   console.log(formTypes, this.router.url);
  //
  //   for (let i = 0; i < formTypes.length; i++) {
  //     console.log("day ne con di", formTypes[i], this.router.url);
  //     if (this.router.url.includes(formTypes[i])) {
  //
  //       this.isOpeningForm = true;
  //       break;
  //     }
  //   }
  //
  //   console.log(this.isOpeningForm);
  //
  //   if (this.router.url.includes('action')) {
  //     // getting information from url
  //     const URLActionName = this.route.snapshot.paramMap.get('action');
  //     const URLFormName = this.route.snapshot.paramMap.get('formName');
  //     const URLAssessCaseID = this.route.snapshot.paramMap.get('assessCaseID');
  //
  //     this.debug.log(URLActionName);
  //     this.debug.log('ASSESS CASE ID: ', URLAssessCaseID);
  //     this.debug.log(URLFormName);
  //     // if the application is assigning the form to user
  //     if (URLActionName == 'assign') {
  //
  //       this.actionHandlerService.updateCurrentCaseId.next(URLAssessCaseID);
  //       this.router.navigateByUrl(
  //         `stage/${this.buildingId}/monitoring/${URLFormName}/${URLAssessCaseID}`
  //       );
  //       // if the application is reviewing the form to user
  //     } else if (URLActionName == 'review') {
  //       this.debug.log("GOING TO REVIEW MONITORING!");
  //     }
  //   }
  //
  //   console.log(this.isOpeningForm);
  // }
  //
  // startRoarActivityReview(p_case): void {
  //
  //   const formNames = AssessForms.names.monitoring;
  //   const thisFormName = Array.isArray(formNames) ? formNames[1] : formNames;
  //   localStorage.setItem('formsFormName', thisFormName);
  //   if (this.isOpeningForm) {
  //     this.isOpeningForm = false;
  //     this.actionHandlerService.updateCurrentCaseId.next('');
  //     this.actionHandlerService.updateCurrentStudentName.next('');
  //     this.router.navigate([`stage/${this.buildingId}/monitoring`]);
  //   } else {
  //     this.isOpeningForm = true;
  //     const _subId = p_case?.LastAction?.find(
  //       (w) => w.ActionName == 'Threat Assessment Screen Submitted'
  //     )?.SubmissionId;
  //     const _path = `stage/${this.buildingId}/monitoring/request/${p_case.CaseId}/review/${thisFormName}/${_subId}`;
  //     console.log('navigating to:', _path);
  //     this.modalService.dismissAll();
  //     this.router.navigate([_path]);
  //   }
  // }
  //
  // submitAssessmentTeam() {
  //   // prepare data for api request
  //   const checkedUsers = this.assessmentTeamList.filter(
  //     (user) => user.isChecked
  //   );
  //   this.debug.log(checkedUsers);
  //   const userIDs = [];
  //   for (let i = 0; i < checkedUsers.length; i++) {
  //     userIDs.push(checkedUsers[i].userId);
  //   }
  //   this.debug.log(this.buildingId, this.currentCase.CaseUID, userIDs);
  //
  //   const buildingId = parseInt(this.buildingId);
  //   const assessCaseUID = this.currentCase.CaseUID;
  //
  //   if (this.isSelectingTeamMember) {
  //     this.assessService
  //       .updateThreatAssessmentTeam(buildingId, assessCaseUID, userIDs)
  //       .subscribe(
  //         (result: any) => {
  //           if (result.statusCode == 200) {
  //             this.toastr.success(
  //               'The assessment team has been submitted!',
  //               'Message:'
  //             );
  //           } else {
  //             this.toastr.error(result.description, 'Error:');
  //           }
  //           this.debug.log(result);
  //
  //           //reload data
  //           this.loadData();
  //
  //           //reset modal and dismiss the modal---------------
  //           this.assessmentTeamList.forEach(
  //             (person) => (person.isChecked = false)
  //           );
  //           this.modalService.dismissAll();
  //         },
  //         (error) => {
  //           this.toastr.error(error.description, 'Error:');
  //           this.debug.log(error);
  //         }
  //       );
  //   } else {
  //     // call api for assign task to another person using text/email-----------------------------
  //     for (let i = 0; i < userIDs.length; i++) {
  //       const currentUserId = userIDs[i];
  //
  //       this.assessService
  //         .assignTeamAssessmentSelectionTask(
  //           buildingId,
  //           this.currentClickedCaseId,
  //           currentUserId,
  //           `Assign Threat Assessment Team Members`,
  //           ''
  //         )
  //         .subscribe((res: any) => {
  //           if (res.statusCode == 200) {
  //             this.modalService.dismissAll();
  //             this.toastr.success(
  //               'The message has been sent to the target user!'
  //             );
  //           }
  //         });
  //     }
  //   }
  // }
  //
  // chooseForm(formNumber: number, caseId: string) {
  //
  //   const formNames = AssessForms.names.monitoring;
  //   const thisFormName = Array.isArray(formNames)
  //     ? formNames[formNumber - 1]
  //     : formNames;
  //   if (this.isOpeningForm) {
  //     this.isOpeningForm = false;
  //     this.router.navigate([`stage/${this.buildingId}/monitoring`]);
  //   } else {
  //     this.isOpeningForm = true;
  //     localStorage.setItem('selectedAssessCaseId', caseId);
  //     this.router.navigate([
  //       `stage/${this.buildingId}/monitoring/${thisFormName}/${caseId}`,
  //     ]);
  //   }
  // }
  //
  // loadData() {
  //   //load data from the
  //   this.assessService
  //     .getAssessInfoByBuildingID(parseInt(this.buildingId))
  //     .subscribe({
  //       next: (res: any) => {
  //         this.monitoringData = this.getMonitoringData(res.data);
  //
  //         this.temp = [...this.monitoringData];
  //
  //         //set up the assessment team data
  //         this.assessmentTeamList = [];
  //         res.assessUsers.forEach((user) => {
  //           if (user.permissions?.settingsPermissions?.
  //             assess_permissions?.canReviewAssessments == true) {
  //             this.assessmentTeamList.push({
  //               userId: user.userID,
  //               userDisplayName: user.userDisplayName,
  //               isChecked: false,
  //             });
  //           }
  //         });
  //
  //         //update current case number--------------------------------------------
  //         const dataArray = res.data;
  //
  //         this.stageJobsCount.Evaluations = 0;
  //         this.stageJobsCount.Assessments = 0;
  //         this.stageJobsCount.Plans = 0;
  //         this.stageJobsCount.Interventions = 0;
  //         this.stageJobsCount.Monitoring = 0;
  //         this.stageJobsCount.Closed = 0;
  //
  //         for (let i = 0; i < dataArray.length; i++) {
  //           const data = dataArray[i].CurrentStage;
  //
  //           if (data == 'Evaluations') {
  //             this.stageJobsCount.Evaluations += 1;
  //           }
  //           if (data == 'Assessments') {
  //             this.stageJobsCount.Assessments += 1;
  //           }
  //           if (data == 'RMS-Plans') {
  //             this.stageJobsCount.Plans += 1;
  //           }
  //           if (data == 'Interventions') {
  //             this.stageJobsCount.Interventions += 1;
  //           }
  //           if (data == 'Monitoring') {
  //             this.stageJobsCount.Monitoring += 1;
  //           }
  //           if (data == 'Closed') {
  //             this.stageJobsCount.Closed += 1;
  //           }
  //         }
  //
  //         this.actionHandlerService.currentCaseNumber.next(this.stageJobsCount);
  //         //end update current case number--------------------------------------------
  //
  //         // console.log(this.evaluationsData);
  //       },
  //       error: (err: any) => {
  //         console.log(err);
  //       },
  //     });
  // }
  //
  // getMonitoringData(apiResponse: IAssessCaseInfo[]) {
  //   const dataArray = [];
  //
  //   // console.log("start debug here");
  //
  //   // console.log(apiResponse);
  //
  //   apiResponse.forEach((data: any) => {
  //     dataArray.push(data);
  //   });
  //
  //   // console.log(dataArray);
  //
  //   const mornitoringArray = [];
  //
  //   dataArray.forEach((data: any) => {
  //     console.log(data);
  //
  //
  //     if (data.CurrentStage == "Monitoring") {
  //       mornitoringArray.push(data);
  //     }
  //   });
  //
  //   return mornitoringArray.reverse();
  //
  // }
  //
  // formatDate(dateString: string) {
  //   const datepipe: DatePipe = new DatePipe('en-US');
  //   return datepipe.transform(dateString, 'dd-MMM-YYYY HH:mm:ss');
  // }
  //
  // updateFilter(event) {
  //   const val = event.target.value.toLowerCase();
  //   // filter our data
  //   const temp = this.temp.filter(function (d) {
  //     return d.CaseId.toLowerCase().indexOf(val) !== -1
  //       || d.LastUpdatedByName.toLowerCase().indexOf(val) !== -1
  //       || d.IncidentSummary.toLowerCase().indexOf(val) !== -1
  //       || !val;
  //   });
  //   // update the rows
  //   this.monitoringData = temp;
  //   // Whenever the filter changes, always go back to the first page
  //   this.table.offset = 0;
  // }
  //
  // getDataFromActivityArray(actArray: any[]) {
  //   if (!(actArray?.length > 0))
  //     return null;
  //
  //   const res =
  //
  //     actArray[actArray.length - 1].Action +
  //     ' (' +
  //     actArray[actArray.length - 1].ActionName + ')';
  //   return res;
  // }
  //
  // open(content) {
  //   // this.debug.log(content);
  //   this.modalService
  //     .open(content, {
  //       ariaLabelledBy: 'modal-basic-title',
  //       backdrop: 'static',
  //       keyboard: false,
  //       size: 'lg'
  //     })
  //     .result.then(
  //       (result) => {
  //         this.closeResult = `Closed with: ${result}`;
  //       },
  //       (reason) => {
  //         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //       }
  //     );
  // }
  //
  // private getDismissReason(reason: any): string {
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return `with: ${reason}`;
  //   }
  // }
  //
  // rowClickHandler(event) {
  //   if (event.type == 'click') {
  //     this.actionHandlerService.updateCurrentStudentName.next(event.row.IncidentContact.ContactFirstName + " " + event.row.IncidentContact.ContactLastName);
  //     this.actionHandlerService.updateCurrentCaseId.next(event.row.CaseId);
  //     this.currentCase = event.row;
  //     this.debug.log(this.currentCase);
  //     this.currentClickedCaseId = event.row.CaseId;
  //     this.currentActionHistory = event.row.LastAction;
  //
  //     // for showing attachments
  //     this.attachmentsCompletedForms = this.currentCase.Attachments?.completedForms;
  //     this.attachmentsInProgressForms = this.currentCase.Attachments?.InProgressForms;
  //     this.attachmentsFileLinks = this.currentCase.Attachments?.fileLinks;
  //   }
  // }
  //
  // closeForm() {
  //   this.isOpeningForm = false;
  //   this.sidebarHighlighter.highlightSideBar(this.router);
  //   this.router.navigateByUrl(`stage/${this.buildingId}/monitoring`);
  //   this.actionHandlerService.updateCurrentCaseId.next('');
  //   this.actionHandlerService.updateCurrentStudentName.next('');
  // }
  //
  // // check if users submitted the case assessment form or not
  // isMonitoringSubmitted(currentCase) {
  //   let isSubmitted = false;
  //
  //   const lastAction = currentCase.LastAction;
  //
  //   for (let i = 0; i < lastAction.length; i++) {
  //     if (
  //       lastAction[i].ActionName === 'Full Team Threat Assessment Submitted'
  //     ) {
  //       isSubmitted = true;
  //       break;
  //     }
  //   }
  //
  //   return isSubmitted;
  // }
  //
  // // check if the assessment has been assigned or not
  // isAbleToAssignAssessmentTeam(currentCase) {
  //
  //   if (this.hasCanManageCasesPermission()) return true;
  //
  //   // ----if the case is not assigned to the team, then false
  //   if (!currentCase.AssignedTeam) return false;
  //
  //   const assignedUsersArray: any[] = currentCase.AssignedTeam?.Users;
  //
  //   for (let j = 0; j < assignedUsersArray.length; j++) {
  //     const teamUserId = assignedUsersArray[j].id;
  //     if (this.currentUserId == teamUserId) {
  //       return true;
  //     }
  //   }
  //   return true;
  // }
  //
  // // check if the user has canManageCases permission or not
  // hasCanManageCasesPermission() {
  //   const currentUserID = this.currentUserId;
  //   for (let i = 0; i < this.assessmentTeamList.length; i++) {
  //     if (this.assessmentTeamList[i].userId?.toString() == currentUserID) {
  //       return this.assessmentTeamList[i].permissions?.settingsPermissions?.assess_permissions?.canManageCases == true
  //     }
  //   }
  //   return false;
  // }
  //
  // openTeamSelectingModal() {
  //   this.debug.log(
  //     'THE CURRENT CASE HERE!!!!',
  //     this.currentCase,
  //     this.assessmentTeamList
  //   );
  //
  //   this.assessmentTeamList.forEach((member) => {
  //     member.isChecked = false;
  //   });
  //
  //   // show current selected assessmen team member
  //   if (this.currentCase.AssignedTeam) {
  //     const currentAssignedUsers: any[] = this.currentCase.AssignedTeam.Users;
  //
  //     const assignedUserIdArray = [];
  //     currentAssignedUsers.forEach((user) => {
  //       const currentAssignedUserId = user.id;
  //       assignedUserIdArray.push(currentAssignedUserId);
  //     });
  //
  //     this.assessmentTeamList.forEach((member) => {
  //       this.debug.log(assignedUserIdArray);
  //       this.debug.log(member);
  //       if (assignedUserIdArray.includes(member.userId + '')) {
  //         member.isChecked = true;
  //       }
  //     });
  //   }
  //   //--------------------------------------------
  //
  //   this.isSelectingTeamMember = true;
  //   this.teamSelectionTitle = `Team Selection for the Case ${this.currentClickedCaseId}`;
  //   this.open(this.designatedTeamSelectionModal);
  // }
  // openAssignTaskModal() {
  //   this.isSelectingTeamMember = false;
  //   this.teamSelectionTitle = `Assign assessment task to other people for the Case ${this.currentClickedCaseId}`;
  //   this.open(this.designatedTeamSelectionModal);
  // }
  //
  // backToDecision() {
  //   this.modalService.dismissAll();
  //   this.open(this.teamSelectionConsiderModal);
  // }
  //
  // isAbleToCreate(currentCase: IAssessCaseInfo, formNumber: number) {
  //   if (!currentCase.AssignedTeam)
  //     return false;
  //
  //   if (formNumber >= AssessForms.names.plans.length)
  //     return false;
  //
  //   const thisFormName = AssessForms.names.plans[formNumber - 1];
  //
  //   switch (thisFormName) {
  //     case 'assess-rms-checklist':
  //       if (this.assessService.caseHasReviewedForm(currentCase, 'assess-rms-checklist'))
  //         return false;
  //       break;
  //     case 'assess-roar-assignment':
  //       if (!this.assessService.caseHasReviewedForm(currentCase, 'assess-rms-checklist'))
  //         return false;
  //       break;
  //     case 'assess-rms-review-schedule':
  //       if (!this.assessService.caseHasReviewedForm(currentCase, 'assess-rms-checklist'))
  //         return false;
  //       break;
  //     case 'assess-rms-summary':
  //       if (!this.assessService.caseHasReviewedForm(currentCase, 'assess-rms-checklist'))
  //         return false;
  //       break;
  //     default:
  //       return false;
  //   }
  //
  //   return currentCase.AssignedTeam?.Users?.
  //   findIndex(w => w.id?.toString() == this.currentUserId?.toString()) > -1;
  // }
  //
  // // check if users submitted the case assessment form or not
  // // and check if the current user is assigned to this case.
  // isAbleToReview(currentCase: IAssessCaseInfo, formNumber: number) {
  //   // if the case is not assigned to the team, then cannot review anything.
  //   if (!currentCase.AssignedTeam)
  //     return false;
  //
  //   if (formNumber >= AssessForms.names.plans.length
  //     || !this.assessService.caseHasReviewRequestForForm(currentCase, AssessForms.names.plans[formNumber - 1]))
  //     return false;
  //
  //   return currentCase.AssignedTeam?.Users?.
  //   findIndex(w => w.id?.toString() == this.currentUserId?.toString()) > -1;
  // }
  //
  // // // ***********************************************************************
  // // // Able to create form when:                                             *
  // // // The team has been assigned                                            *
  // // // There are no Full Threat Assessment create before by the current user *
  // // // ***********************************************************************
  // // isAbleToCreateMonitoring(currentCase) {
  // //   // if the current user in assessment team -----------------------------
  // //   // this.debug.log("THE CURRENT USER ID HERE!!!!", this.currentUserId);
  // //   let isCurrentUserInTeamAssessment = false;
  // //
  // //   // ----if the case is not assigned to the team, then false
  // //   if (!currentCase.AssignedTeam) return false;
  // //
  // //   const assignedUsersArray: any[] = currentCase.AssignedTeam.Users;
  // //
  // //   for (let j = 0; j < assignedUsersArray.length; j++) {
  // //     const teamUserId = assignedUsersArray[j].id;
  // //     // this.debug.log("IN TEAM USER ID!!", teamUserId);
  // //
  // //     if (this.currentUserId + '' == teamUserId + '') {
  // //       isCurrentUserInTeamAssessment = true;
  // //       break;
  // //     }
  // //   }
  // //   // end of if the current user in assessment team ----------------------
  // //
  // //   // if there is no full threat assessment submitted by the current user
  // //   let isNotSubmittedFullThreatAssessment = true;
  // //   // const lastAction = currentCase.LastAction;
  // //   // for (let i = 0; i < lastAction.length; i++) {
  // //   //   if (
  // //   //     // if the 'Full Team Threat Assessment Submitted' did submit, then user cannot create a form
  // //   //     lastAction[i].ActionName === 'RMS Plan Documentation Submitted' &&
  // //   //     lastAction[i].TakenBy + '' == this.currentUserId + ''
  // //   //   ) {
  // //   //     isNotSubmittedFullThreatAssessment = false;
  // //   //   }
  // //   // }
  // //   // end of if there is no full threat assessment submitted by the current user
  // //
  // //   // this.debug.log("KET QUA CON ME MAY NE!!!!", isCurrentUserInTeamAssessment, isNotSubmittedFullThreatAssessment)
  // //
  // //   return isCurrentUserInTeamAssessment && isNotSubmittedFullThreatAssessment;
  // // }
  //
  // // // check if users submitted the case assessment form or not
  // // // and check if the current user is assigned to this case.
  // // isAbleToReview(currentCase) {
  // //   // if the case is not assigned to the team, then cannot review anything.
  // //   if (!currentCase.AssignedTeam) return false;
  // //
  // //   let isMadeForm = false;
  // //   const lastAction = currentCase.LastAction;
  // //   for (let i = 0; i < lastAction.length; i++) {
  // //     if (
  // //       lastAction[i].ActionName === 'RMS Plan Documentation Submitted'
  // //       //need to check if the case is submitted by current user or not
  // //     ) {
  // //       isMadeForm = true;
  // //     }
  // //   }
  // //
  // //   let isAssignedToTheCase = false;
  // //
  // //   if (currentCase.AssignedTeam) {
  // //
  // //     const assignedUsers = currentCase.AssignedTeam.Users;
  // //     for (let i = 0; i < assignedUsers.length; i++) {
  // //       if (assignedUsers[i].id == this.currentUserId) {
  // //         isAssignedToTheCase = true;
  // //         break;
  // //       }
  // //     }
  // //   }
  // //
  // //   return (isMadeForm && isAssignedToTheCase);
  // // }
  //
  // viewDownloadClick(event: any, assessCaseId?: string, formName?: string, submissionId?: string, download?: boolean) {
  //   this.debug.log("Assessments.Component - viewDownloadClick executed. event:", event, "assessCaseId", assessCaseId, "submissionId:", submissionId);
  //   this.assessService.viewOrDownloadReport(event, assessCaseId, formName, submissionId, download);
  // }
}
